import { unsafeCSS } from 'lit';
import { styles as componentStyles } from './view.scss';
import { styles as commonStyles } from '../../../assets/common.scss';

export const styles = [unsafeCSS(`${commonStyles}`), unsafeCSS(`${componentStyles}`)];
